module.exports = __webpack_public_path__ + "img/empty-notification.28c7de5a.svg";